<template>
  <div class="container-fluid">
    <!-- Bread-crumb-->
    <div class="block-header">
      <bread-crumb></bread-crumb>
    </div>
    <div class="row clearfix">
      <div class="col-lg-12">
        <div class="card card-top-line">
          <!-- Header -->
          <div class="header">
            <h2>Create Coupon Code</h2>
          </div>
          <div class="body">
            <ValidationObserver v-slot="{ passes }">
              <form @submit.prevent="passes(createCoupon)" id="basic-form">
                <ValidationProvider
                  name="code"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <div
                    class="form-group"
                    :class="{
                      errors: errors.length && !addcouponCode.code,
                      success: addcouponCode.code,
                    }"
                  >
                    <span class="float-label">
                      <input
                        type="text"
                        v-model="addcouponCode.code"
                        class="form-control"
                        id="name"
                        placeholder="First Name*"
                      />
                      <label for="name" class="control-label">
                        Coupon code*
                      </label>
                      <div class="line"></div>
                      <i
                        class="fa fa-times"
                        v-if="errors.length && !addcouponCode.code"
                      ></i>
                      <i class="fa fa-check" v-if="addcouponCode.code"></i>
                    </span>
                  </div>
                </ValidationProvider>
                <div
                  class="phone-with-country d-flex justify-content-between align-items-center"
                >
                  <div class="select-country">
                    <div class="form-group form-select single-multiselect">
                      <span class="float-label">
                        <multiselect
                          placeholder=""
                          v-model="addcouponCode.discount_type"
                          :show-labels="false"
                          :options="['Flat', 'Percentage']"
                          :searchable="false"
                          :allow-empty="false"
                        ></multiselect>
                      </span>
                    </div>
                  </div>
                  <div class="add-number">
                    <ValidationProvider
                      name="fastbankdeposit_discount_amount"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <div
                        class="form-group"
                        :class="{
                          errors: errors.length && !addcouponCode.discount,
                          success: addcouponCode.discount,
                        }"
                      >
                        <span class="float-label">
                          <input
                            type="text"
                            v-model="addcouponCode.discount"
                            class="form-control"
                            id="discount_amount"
                            placeholder="0.00"
                          />
                          <label for="discount_amount" class="control-label">
                            Discount*
                          </label>
                          <div class="line"></div>
                          <i
                            class="fa fa-times"
                            v-if="errors.length && !addcouponCode.discount"
                          ></i>
                          <i
                            class="fa fa-check"
                            v-if="addcouponCode.discount"
                          ></i>
                        </span>
                      </div>
                    </ValidationProvider>
                  </div>
                </div>
                <ValidationProvider
                  name="total_issued"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <div
                    class="form-group"
                    :class="{
                      errors: errors.length && !addcouponCode.total_issued,
                      success: addcouponCode.total_issued,
                    }"
                  >
                    <span class="float-label">
                      <input
                        type="text"
                        v-model="addcouponCode.total_issued"
                        class="form-control"
                        id="name"
                        placeholder="First Name*"
                        @keypress="onlyNumber($event)"
                      />
                      <label for="name" class="control-label">
                        Total Coupons Issued*
                      </label>
                      <div class="line"></div>
                      <i
                        class="fa fa-times"
                        v-if="errors.length && !addcouponCode.total_issued"
                      ></i>
                      <i
                        class="fa fa-check"
                        v-if="addcouponCode.total_issued"
                      ></i>
                    </span>
                  </div>
                </ValidationProvider>
                <ValidationProvider
                  name="start_date"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <div
                    class="form-group datepicker"
                    :class="{
                      errors: errors.length && !addcouponCode.start_date,
                      success: addcouponCode.start_date,
                    }"
                  >
                    <span class="float-label">
                      <b-input-group>
                        <div class="input-group-prepend">
                          <span class="input-group-text">Start Date</span>
                          <span
                            class="input-group-text"
                            @click="$refs.birthdate.showCalendar()"
                          >
                            <i class="icon-calendar"></i>
                          </span>
                        </div>
                        <datepicker
                          class="form-control"
                          ref="birthdate"
                          v-model="addcouponCode.start_date"
                          :bootstrap-styling="false"
                          placeholder=""
                          :typeable="true"
                        ></datepicker>
                      </b-input-group>
                      <i
                        class="fa fa-times"
                        v-if="errors.length && !addcouponCode.start_date"
                      ></i>
                      <i
                        class="fa fa-check"
                        v-if="addcouponCode.start_date"
                      ></i>
                    </span>
                  </div>
                </ValidationProvider>
                <ValidationProvider
                  name="end_date"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <div
                    class="form-group datepicker"
                    :class="{
                      errors: errors.length && !addcouponCode.end_date,
                      success: addcouponCode.end_date,
                    }"
                  >
                    <span class="float-label">
                      <b-input-group>
                        <div class="input-group-prepend">
                          <span class="input-group-text">End Date</span>
                          <span
                            class="input-group-text"
                            @click="$refs.birthdate.showCalendar()"
                          >
                            <i class="icon-calendar"></i>
                          </span>
                        </div>
                        <datepicker
                          class="form-control"
                          ref="birthdate"
                          v-model="addcouponCode.end_date"
                          :bootstrap-styling="false"
                          placeholder=""
                          :typeable="true"
                        ></datepicker>
                      </b-input-group>
                      <i
                        class="fa fa-times"
                        v-if="errors.length && !addcouponCode.end_date"
                      ></i>
                      <i class="fa fa-check" v-if="addcouponCode.end_date"></i>
                    </span>
                  </div>
                </ValidationProvider>
                <ValidationProvider
                  name="status"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <div
                    class="form-group form-select single-multiselect select-option-custom"
                    :class="{
                      errors: errors[0],
                      success: addcouponCode.status && !errors[0],
                    }"
                  >
                    <span class="float-label">
                      <label for="status">Select Status*</label>
                      <multiselect
                        placeholder=""
                        v-model="addcouponCode.status"
                        :show-labels="false"
                        :options="['Active', 'InActive']"
                      ></multiselect>
                      <i
                        class="fa fa-times"
                        v-if="errors.length && errors[0]"
                      ></i>
                      <i
                        class="fa fa-check"
                        v-if="addcouponCode.status && !errors[0]"
                      ></i>
                    </span>
                  </div>
                </ValidationProvider>
                <div
                  class="d-flex flex-column flex-md-row justify-content-center"
                >
                  <b-button
                    variant="secondary btn-mw"
                    size="lg"
                    @click="$router.push({ path: '/coupon-managment/list' })"
                  >
                    Cancel
                  </b-button>
                  <b-button
                    type="submit"
                    variant="primary ml-md-1 mt-2 mt-md-0 btn-mw"
                    size="lg"
                  >
                    Submit
                  </b-button>
                </div>
              </form>
            </ValidationObserver>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
const { ValidationObserver, ValidationProvider } = require("vee-validate");
export default {
  name: "CreateCouponComponent",
  components: {
    BreadCrumb: () => import("@/components/BreadCrumb.vue"),
    ValidationObserver,
    ValidationProvider,
    Multiselect: () => import("vue-multiselect"),
    Datepicker: () => import("vuejs-datepicker"),
  },
  methods: {
    createCoupon() {
      console.log(this.addcouponCode);
    },
    onlyNumber(event) {
      let keyCode = event.keyCode ? event.keyCode : event.which;
      if (keyCode < 48 || keyCode > 57) {
        event.preventDefault();
      }
      if (/^\W$/.test(event.key)) {
        event.preventDefault();
      }
    },
  },
  data() {
    return {
      addcouponCode: {
        code: "",
        discount: "",
        discount_type: "Flat",
        total_issued: "",
        start_date: "",
        end_date: "",
        status: "",
      },
    };
  },
};
</script>
